import React from 'react';
import useFetch from "../../services/useFetch.js"
import MetricCard from '../ui/MetricCard';

export default function LowestMenuItem({ reload }) {
    const { data, load } = useFetch('api/menu-margin/lowest', reload);

    return (
        <MetricCard
            label="Lowest margin"
            loading={load}
            value={data?.profitMargin != null ? `${Number(data.profitMargin).toFixed(1)}%` : '—'}
            detail={data?.posMenuItem || 'No margin data'}
        />
    );
}
